<script lang="ts">
  import { getContext } from "svelte";
  import InnerContainer from "../internal/InnerContainer.svelte";
  import OptionContainer from "../internal/OptionContainer.svelte";
  import TitleDescription from "../internal/TitleDescription.svelte";
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import cx from "classnames";
  import { selectedKey, type Select } from "./OptionGroup.svelte";
  import { Check } from "$components/+blocks/OVIcon";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";
  import type { Writable } from "svelte/store";

  export let title: string;
  export let value: string | object | undefined = title;
  export let key: (x: any) => string = (x) => x;
  export let description = "";
  export let isDescriptionInline = false;
  export let reverseOrder = false;
  export let icon: IconType | undefined = undefined;
  export let iconColor: string | undefined = undefined;
  export let avatar: string | undefined = undefined;
  export let showAvatar = false;
  export let tooltipCopy = "";
  export let closeOnTrigger = true;
  export let customIconUrl: string | undefined = undefined;

  let selected = getContext<Writable<Select>>(selectedKey);

  $: isSelected = $selected?.selected?.some((item) => key(item) === key(value));
</script>

<OptionContainer {title} {value} {key} {closeOnTrigger} on:click>
  <InnerContainer {description} {isDescriptionInline} {isSelected} {reverseOrder} {tooltipCopy}>
    {#if customIconUrl}
      <Avatar mainImage={customIconUrl} radius="rounded-[3px]" />
    {:else if icon}
      <span style:color={iconColor} class={iconColor}>
        <OVIcon {icon} class="mt-0.5 shrink-0 opacity-80" />
      </span>
    {/if}
    {#if showAvatar}
      <Avatar radius="rounded-[3px]" mainImage={avatar} label={title[0]} />
    {/if}

    <TitleDescription {title} {description} {isDescriptionInline} />

    <span class="size-4" class:ml-auto={!reverseOrder}>
      {#if isSelected}
        <OVIcon icon={Check} class={cx({ "mt-0.5": description })} />
      {/if}
    </span>
  </InnerContainer>
</OptionContainer>
